import React from "react";
import LinearProgress from "@mui/material/LinearProgress";
import styles from "../styles/loadingBar.module.css";
export default function LoadingBar() {
  return <div className={styles.loading_container} data-sentry-component="LoadingBar" data-sentry-source-file="loadingBar.jsx">
      <LinearProgress color="inherit" data-sentry-element="LinearProgress" data-sentry-source-file="loadingBar.jsx" />
    </div>;
}